import { Injectable } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { SharedService } from './shared.Service';
import { AuthService } from '../auth/auth.service';
import { PermissionService } from './permission/permission.service';

@Injectable()
export class RoutingService {
    public role: any;
    sideMenus: Array<any>;
    constructor(private authService: AuthService, private permissionService: PermissionService,
        private sharedService: SharedService) {
        this.sideMenus = [];
        this.role = this.sharedService.sessionVar;
        if (!this.sharedService.sessionVar) {
            this.logout();
        }
        if (this.sharedService.permissionList.length === 0) {
            this.logout();
        }
    }

    navigateTo(event: NavigationStart): string {
        let url = event.url;
        this.role = this.sharedService.sessionVar;
        const role = this.role.toLowerCase();
        switch (role) {
            case role === 'super admin': case role === 'admin':
                if (url === '/' || url === '/pages/login') {
                    url = this.defaultRoutebyRole(this.role);
                } else if (url === '/') {
                    url = this.defaultRouteTo(url);
                } else {
                    url = this.checkPermission(url) ? url : '/pages/unauthorized';
                }
                break;
            default:
                if (url === '/pages/login') {
                    url = this.defaultRoutebyRole(this.role);
                } else if (url === '/' || url === '/pages/unauthorized') {
                    url = this.defaultRouteTo(url);
                } else {
                    url = this.checkPermission(url) ? url : '/pages/unauthorized';
                }
                break;
        }
        return url.toLowerCase();
    }

    // routes to landing-page before login if user is try to access authorized pages
    private defaultRouteTo(url: string): string {
        switch (url) {
            case '/':
            case '/pages/unauthorized':
                break;
            default: url = '/pages/login';
                break;
            // default: url = this.defaultRoutebyRole(this.role);
            //     break;
        }
        return url;
    }

    defaultRoutebyRole(role: string): string {
        this.sharedService.sessionVar = this.role = (role || this.role);
        if (this.sideMenus.length === 0) {
            this.sideMenus = this.permissionService.getNavigationMenus(this.sharedService.permissionList);
            this.sharedService.sideMenus = this.sideMenus;
        }
        const url = (this.sideMenus.length > 0 ? '/pages/profile' : 'comingsoon');
        return url.toLowerCase();
    }

    checkPermission(url: string): boolean {
        let hasPermission = false;
        if (this.sideMenus.length === 0) {
            this.sideMenus = this.permissionService.getNavigationMenus(this.sharedService.permissionList);
        }
        this.sideMenus.forEach((menu) => {
            if (menu.path === null && menu.submenu.length !== 0) {
                for (let i = 0; i < menu.submenu.length; i += 1) {
                    if (url.toLowerCase().indexOf(menu.submenu[i].path) > -1) {
                        hasPermission = true;
                        return hasPermission;
                    }
                }
            } else {
                if (url.toLowerCase().indexOf(menu.path) > -1) {
                    hasPermission = true;
                    return hasPermission;
                }
            }
        })
        return hasPermission;
    }

    logout() {
        this.role = '';
        this.authService.logout();
        this.sideMenus = [];
    }
}
